/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForVulnerabilitiesAws extends models.GovernanceConfigurationBaseForVulnerabilities {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForVulnerabilitiesAws");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForVulnerabilitiesAws.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForVulnerabilitiesAws>): GovernanceConfigurationForVulnerabilitiesAws {
        let obj = Object.assign(new GovernanceConfigurationForVulnerabilitiesAws(), model);
        GovernanceConfigurationForVulnerabilitiesAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForVulnerabilitiesAws>): GovernanceConfigurationForVulnerabilitiesAws {
        if (!model) return null;
        return GovernanceConfigurationForVulnerabilitiesAws.newInstance(<GovernanceConfigurationForVulnerabilitiesAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForVulnerabilitiesAws) {
        if (!obj) return;

        models.GovernanceConfigurationForVulnerabilitiesAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForVulnerabilitiesAws): boolean {
        if (models.GovernanceConfigurationBaseForVulnerabilities.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForVulnerabilitiesAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
